import type { Photo } from "~/api";

const roundUpToNearest = (num: number, upTo = 600) =>
  Math.ceil(num / upTo) * upTo;

export const usePhoto = (
  photo: Photo | Ref<Photo> | ComputedRef<Photo>,
  size: MaybeRef<number>,
) => {
  const isPhoto = computed(() =>
    ["image/jpeg"].includes(unref(photo).mimetype)
  );

  const isVideo = computed(() => ["video/mp4"].includes(unref(photo).mimetype));

  const imageUrl = computed(() =>
    unref(photo).url?.replace("{size}", String(roundUpToNearest(unref(size))))
  );

  const videoUrl = computed(() => unref(photo).url ?? undefined);

  const url = computed(() => {
    if (isPhoto.value) {
      return imageUrl.value;
    } else if (isVideo.value) {
      return videoUrl.value;
    } else {
      return undefined;
    }
  });

  const downloadFilename = computed(() => {
    // if (isPhoto.value) {
    //   return `${unref(photo).slug}.jpg`;
    // } else if (isVideo.value) {
    //   return `${unref(photo).slug}.mp4`;
    // } else {
    //   return undefined;
    // }

    return unref(photo).filename;
  });

  return {
    isPhoto,
    isVideo,
    // imageWidth,
    // imageHeight,
    // aspectRatio,
    imageUrl,
    videoUrl,
    url,
    downloadFilename,
  };
};
